import {Component, OnDestroy, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {ApiService} from '../../services/api';
import {ActivatedRoute, Router} from '@angular/router';
import {UserContext} from '../../services/user-context';
import {BehaviorSubject, Observable, Subject, Subscription} from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import {CardDialogComponent} from './components/card-dialog/card-dialog.component';
import {ConfirmDialogComponent} from '../../shared/layout/components/confirm-dialog/confirm-dialog.component';
import {DataStateChangeEvent, GridDataResult, SelectionEvent} from '@progress/kendo-angular-grid';
import {AccountDialogComponent} from './components/account-dialog/account-dialog.component';
import {State} from '@progress/kendo-data-query';
import {ClientSessionService} from '../../clients/client-sessions.service';
import {debounceTime, distinctUntilChanged} from 'rxjs/operators';
import {ClientsService} from '../../clients/clients.service';
import {SearchContext} from '../../services/search/search-context';
import {CommissionDialogComponent} from './components/commissions/commission-dialog.component';
import {BankAccountComponent} from '../../bank/bank-account.component';
import {LoadingIndicatorService} from '../../shared/layout/components/loading-indicator';
import {PaymentSourceComponent} from '../../source/payment-source.component';
import {Title} from '@angular/platform-browser';
import {ShopifyIntegrationDialogComponent} from './components/integrations/shopify/shopify-integration-dialog.component';

@Component({
  selector: 'app-account-detail',
  encapsulation: ViewEncapsulation.None,
  templateUrl: 'account-detail.template.html',
  styleUrls: [
    './account-detail.style.scss'
  ]
})
export class AccountDetailComponent implements OnInit, OnDestroy {

  public crumbs: any[] = [
    {label: 'Accounts', link: '/accounts'}
  ];

  public integrations:any[] = [
    {handle: 'shopify', title:"Shopify", logo:"/assets/integration-shopify.svg", dialog:"ShopifyIntegrationDialogComponent", background:"#ffffff"}
    ];
  public lat = 35.268107;
  public lng = -90.744821;
  public zoom = 4;

  public accountId: string;
  public account: any;
  accountSubscription:Subscription;
  public sessions: Observable<GridDataResult>;
  public selectedCard: any;
  public stripeCustomer: any;
  public waivers: [any];
  websiteLink:string;
  websiteLocationId:string;
  locations:any[];
  public optionsUpdated = false;
  public selectedOptions:string[] = [];

  public sessionState: State = {
    skip: 0,
    take: 5
  };
  connectAccountTypes: Array<any> = [{
    text: 'Register as an individual',
    type: "individual"
  }, {
    text: 'Register as a business',
    type: 'company'
  }];
  private searchSubscription: Subscription;

  billingModels = ['invoice', 'partner'];

  options = [
    {option:"installments",label:"Allow Installments",description:"Allow installment payments for clients for up to 6 months."},
    {option:"publish",label:"Allow Publishing",description:"Allow users to publish articles for patient content."},
    {option:"orthotics",label:"Enable Orthotics",description:"Enable orthotic order management."},
    {option:"override",label:"Allow Price Override",description:"Allow technician to override pricing by discount."},
    {option:"commissions",label:"Enable Commissions",description:"Enable commission payments for account."},
    {option:"payouts",label:"Enable Payouts",description:"Enable commission payouts for curators."},
    {option:"syndication",label:"Enable Syndication",description:"Enable guest telehealth sessions."},
    {option:"promotions",label:"Promotion Codes",description:"Enable promotion codes for account."},
    {option:"deposits",label:"Accept Deposits",description:"Allow partial payments as a deposit."},
    {option:"dealwindow",label:"Deal Window",description:"Enable deal window interactivity."},
    {option:"voiceassist",label:"Voice Assist",description:"Enable voice commands within Telecart."},
    {option:"creditscore",label:"Credit Score",description:"Enable credit score reporting."},
    {option:"dropShip",label:"Drop Ship",description:"Enable drop shipping for account; products delivered to client."},
    {option:"professional",label:"Professional Options",description:"Enable professional options in apps."},
    {option:"telemedicine",label:"Enable Telemedicine",description:"Enable telemedicine platform."},
    {option:"emr",label:"Enable EMR Options",description:"Enable charting, intake, prescriptions, diagnostics."},
    {option:"telecart",label:"Enable Telecart",description:"Enable curated shopping over video session."},
    {option:"franchise",label:"Franchise Account",description:"Enable franchise and franchisee options."},
    {option:"demo",label:"Demo Account",description:"Run apps in demo mode where applicable. Orders are not sent to suppliers."},
  ];

  public templateSteps: string[] = [
    'Patient',
    'Contact',
    'Physical',
    'Compression',
    'Insurance',
    'Treatments',
    'Lifestyle',
    'Visit',
    'Goal',
    'Target',
    'Complaint',
    'Questionnaire',
    'Diagnoses',
    'Muskoskeletal',
    'Cardiovascular',
    'Neurological',
    'Systemic',
    'Pain',
    'Compliance'
  ];
  public intakeSteps: string[] = [];
  public mapStyles = [
    {elementType: 'geometry', stylers: [{color: '#aec3cb'}]},
    {elementType: 'labels.text.stroke', stylers: [{'visibility': 'off'}]},
    {elementType: 'labels.text.fill', stylers: [{color: '#888888'}]},
    {
      featureType: 'administrative.locality',
      elementType: 'labels.text.fill',
      stylers: [{color: '#555555'}]
    },
    {
      featureType: 'poi',
      elementType: 'labels.text.fill',
      stylers: [{'visibility': 'off'}]
    },
    {
      featureType: 'poi.park',
      elementType: 'geometry',
      stylers: [{color: 'transparent'}]
    },
    {
      featureType: 'poi.park',
      elementType: 'labels.text.fill',
      stylers: [{color: 'transparent'}]
    },
    {
      featureType: 'road',
      elementType: 'geometry',
      stylers: [{color: '#c0d7e0'}]
    },
    {
      featureType: 'road',
      elementType: 'geometry.stroke',
      stylers: [{color: '#bbdefb'}]
    },
    {
      featureType: 'road',
      elementType: 'labels.text.fill',
      stylers: [{color: '#9ca5b3'}]
    },
    {
      featureType: 'road.highway',
      elementType: 'geometry',
      stylers: [{color: '#c0d7e0'}]
    },
    {
      featureType: 'road.highway',
      elementType: 'geometry.stroke',
      stylers: [{color: '#c0d7e0'}]
    },
    {
      featureType: 'road.highway',
      elementType: 'labels.text.fill',
      stylers: [{color: '#81d4fa'}]
    },
    {
      featureType: 'transit',
      elementType: 'geometry',
      stylers: [{color: '#2f3948'}]
    },
    {
      featureType: 'transit.station',
      elementType: 'labels.text.fill',
      stylers: [{color: 'transparent'}]
    },
    {
      featureType: 'water',
      elementType: 'geometry',
      stylers: [{color: '#f1f4f5'}]
    },
    {
      featureType: 'water',
      elementType: 'labels.text.fill',
      stylers: [{color: 'transparent'}]
    },
    {
      featureType: 'water',
      elementType: 'labels.text.stroke',
      stylers: [{color: 'transparent'}]
    }
  ];

  constructor(private route: ActivatedRoute,
              private router: Router,
              public userContext: UserContext,
              public dialog: MatDialog,
              private title: Title,
              public loadingService: LoadingIndicatorService,
              private sessionsService: ClientSessionService,
              private snackBar: MatSnackBar,
              private searchContext: SearchContext,
              private api: ApiService) {

    this.sessions = sessionsService;

    this.api.get<any>(`/account/${(this.userContext.account || {}).id}/location`)
      .subscribe(locations => {
        if (locations) {
          this.locations = locations;
        }
      });
  }


  public ngOnInit(): void {
    this.accountSubscription = this.userContext.accountObserver.subscribe( account => {
      this.account = account || this.userContext.account;
      if( this.account ) {
        if( this.userContext.account ) {
          this.title.setTitle(`${this.userContext.account.name} Link`);
        }
        this.accountId = (this.account || {}).id || this.route.snapshot.paramMap.get('id');
        this.refresh();
      }
    });

    this.searchSubscription = this.searchContext.searchObserver.pipe(debounceTime(400), distinctUntilChanged()).subscribe((term) => {
      if ((term || "").length >= 3 || (term || "").length === 0) {
        this.sessionState.skip = 0;
        this.getSessions();
      }
    });

    this.userContext.fetchAccount();

  }

  public ngOnDestroy(): void {
    this.searchSubscription.unsubscribe();
  }

  public refresh(): void {
    this.account.intake = this.account.intake || {registration: [], followup: [], appointment: []};
    this.selectedOptions = this.account.options || [];
    //this.refreshCards();
    this.refreshWaivers();
  }

  public hasOption(option: string): boolean {
    return (this.account.options || []).includes(option);
  }

  /*
  public toggledOption($event): void {
    if (!this.account.options) {
      this.account.options = [];
    }
    if ($event.checked) {
      if (!this.account.options.includes($event.source.name)) {
        this.account.options.push($event.source.name);
      }
    } else {
      this.account.options = this.account.options.filter( option => option !== $event.source.name);
    }
    this.optionsUpdated = true;

  }*/

  public sessionsStateChange(state: DataStateChangeEvent): void {
    this.sessionState = state;
    this.getSessions();
  }

  public getSessions() {
    const page = this.sessionState.skip / this.sessionState.take + 1;
    const limit = this.sessionState.take;

    this.sessionsService.getSessions(page, limit, () => {
    }, this.searchContext.searchObserver.value || '');
  }


  public toggleOption(event: SelectionEvent): void {
    if (!this.account.options) {
      this.account.options = [];
    }

    this.account.options = this.account.options.filter( o => !event.deselectedRows.map( r => r.dataItem.option ).includes(o));
    this.account.options = this.account.options.concat(event.selectedRows.map( r => r.dataItem.option ));
    this.optionsUpdated = true;
  }

  public managePaymentSources():void {
    const dialogRef = this.dialog.open(PaymentSourceComponent, {
      width: '500px',
      data:{mode:'account'}
    });

    dialogRef.afterClosed().subscribe(external_account => {
    });
  }

  public manageBankAccounts():void {
    const dialogRef = this.dialog.open(BankAccountComponent, {
      width: '700px',
      data:{mode:'account'}
    });

    dialogRef.afterClosed().subscribe(external_account => {
    });
  }

  public requiresExternalAccount():boolean {
    return this.account.connect_id && ((this.account.connect_requirements || {}).currently_due || []).includes("external_account");
  }

  public connectAccount(type:any): void {
    this.api.post<any>(`/account/${this.userContext.account.id}/connect`,{type:type.type})
      .subscribe(result => {
        this.userContext.accountObserver.next(result);
        if( result.connect_id ) {
          this.verifyConnectAccount();
        }
      }, (error) => {
        console.log('Found error ' + JSON.stringify(error));
      });
  }

  public verifyConnectAccount(): void {
    this.api.get<any>(`/account/${this.userContext.account.id}/connect/verify`)
      .subscribe(result => {
        console.log("Received connect: " + JSON.stringify(result));
        if( result.url ) {
          window.location = result.url;
        }
      });
  }

  public updateConnectAccount(): void {
    this.api.get<any>(`/account/${this.userContext.account.id}/connect/update`)
      .subscribe(result => {
        console.log("Received connect: " + JSON.stringify(result));
        if( result.url ) {
          window.location = result.url;
        }
      });
  }


  public refreshCards(): void {
    this.api.get<any>(`/account/${this.accountId}/stripe`)
      .subscribe(stripeResult => {
        this.stripeCustomer = stripeResult;
      }, (error) => {
        console.log('Found error ' + JSON.stringify(error));
      });
  }

  public refreshWaivers(): void {
    this.api.get<any>(`/account/${this.accountId}/waiver`)
      .subscribe(waivers => {
        this.waivers = waivers;

        if((this.waivers || []).length) {
          const waiverLabels = this.waivers.reduce( (titles, waiver) => {return titles.concat(`Waiver: ${waiver.label}`)}, []);

          this.intakeSteps = (this.templateSteps || []).concat(waiverLabels);

          console.log('Found waiver titles: ' + waiverLabels);

        } else {
          this.intakeSteps = this.templateSteps || [];
        }
      }, (error) => {
        console.log('Found error ' + JSON.stringify(error));
      });
  }

  public toggleEnabled(event: any) {
    this.account.enabled = event;

    this.api.patch<any>(`/account/${this.accountId}`, {enabled: this.account.enabled})
      .subscribe( patchResult => {
        this.userContext.accountObserver.next(patchResult);
      }, (error) => {
        console.log('Found error patching ' + JSON.stringify(error));
      });
  }

  public addCardOnFile(): void {
    const dialogRef = this.dialog.open(CardDialogComponent, {
      width: '300px'
    });

    dialogRef.afterClosed().subscribe(result => {

      result.object = 'card';

      this.api.post<any>(`/account/${this.accountId}/stripe`, result)
        .subscribe( cardResult => {
          this.snackBar.open('Card added.', null, {
            duration: 2000
          });
          this.stripeCustomer = cardResult;
        }, (error) => {
          this.snackBar.open(`Error adding card: ${error}`, null, {
            duration: 2000
          });
        });

    });
  }

  public generateWebsiteLink() {
    console.log("Website location id: " + this.websiteLocationId);
    this.websiteLink = `https://healthlink.fitsamerica.com/#/register/${this.userContext.account.id}/${this.websiteLocationId}`;
  }

  copyWebsiteLink() {
    /*
    const pending = this.clipboard.beginCopy(this.websiteLink);
    let remainingAttempts = 3;
    const attempt = () => {
      const result = pending.copy();
      if (!result && --remainingAttempts) {
        setTimeout(attempt);
      } else {
        // Remember to destroy when you're done!
        pending.destroy();
        this.snackBar.open(`Website link copied.`, null, {
          duration: 2000
        });
      }
    };
    attempt();

     */
  }

  public updateCard(): void {
    const dialogRef = this.dialog.open(CardDialogComponent, {
      width: '300px',
      data: this.selectedCard
    });

    dialogRef.afterClosed().subscribe(result => {

      delete result.last4;
      delete result.number;
      delete result.cvc;

      this.api.put<any>(`/account/${this.accountId}/stripe/${this.selectedCard.id}`, result)
        .subscribe( cardResult => {
          this.snackBar.open('Card updated.', null, {
            duration: 2000
          });
          this.stripeCustomer = cardResult;
        }, (error) => {
          this.snackBar.open(`Error updating card: ${error}`, null, {
            duration: 2000
          });
        });

    });
  }

  public showIntegration(integration:any) {
    if( integration.dialog === "ShopifyIntegrationDialogComponent") {
      const dialogRef = this.dialog.open(ShopifyIntegrationDialogComponent, {
        width: '400px',
        data: (this.account.integrations || {})["shopify"] || {}
      });

      dialogRef.afterClosed().subscribe(integration => {
        if ( integration ) {
          this.api.patch<any>(`/account/${this.accountId}`, {
            integrations: Object.assign(this.account.integrations || {}, {shopify: integration})
          }).subscribe( updatedAccount => {
            this.userContext.accountObserver.next(updatedAccount);
            this.snackBar.open('Account integrations updated.', null, {
              duration: 2000
            });
          }, (error) => {
            this.snackBar.open(`Error updating integrations: ${error}`, null, {
              duration: 2000
            });
          });
        }
      });
    }
  }

  public removeCard(): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '300px',
      data: { message: 'Remove this card?', action: 'Remove'}
    });

    dialogRef.afterClosed().subscribe(confirmed => {
      if ( confirmed ) {
        this.api.del<any>(`/account/${this.accountId}/stripe/${this.selectedCard.id}`)
          .subscribe( cardResult => {
            this.snackBar.open('Card removed.', null, {
              duration: 2000
            });
            this.stripeCustomer = cardResult;

          }, (error) => {
            this.snackBar.open(`Error removing card: ${error}`, null, {
              duration: 2000
            });
          });
      }
    });
  }

  public updateOptions(): void {
    this.api.patch<any>(`/account/${this.accountId}`, {
      options: this.account.options
    }).subscribe( patchResult => {
        patchResult.intake = patchResult.intake || {registration: [], followup: [], appointment: []};
        this.account = patchResult;
        this.optionsUpdated = false;
        this.snackBar.open('Account options updated.', null, {
          duration: 2000
        });
      }, (error) => {
        this.snackBar.open(`Error updating options: ${error}`, null, {
          duration: 2000
        });
      });
  }

  public updateServices(): void {
    this.api.patch<any>(`/account/${this.accountId}`, {
      billing: this.account.billing
    }).subscribe( patchResult => {
      patchResult.intake = patchResult.intake || {registration: [], followup: [], appointment: []};
      this.account = patchResult;
      this.snackBar.open('Account services updated.', null, {
        duration: 2000
      });
    }, (error) => {
      this.snackBar.open(`Error updating options: ${error}`, null, {
        duration: 2000
      });
    });
  }


  public updateBilling(): void {
    this.api.patch<any>(`/account/${this.accountId}`, {
      billing: this.account.billing
    }).subscribe( patchResult => {
      patchResult.intake = patchResult.intake || {registration: [], followup: [], appointment: []};
      this.account = patchResult;
      this.snackBar.open('Account services updated.', null, {
        duration: 2000
      });
    }, (error) => {
      this.snackBar.open(`Error updating options: ${error}`, null, {
        duration: 2000
      });
    });
  }

  public updateBranding(): void {
    this.api.patch<any>(`/account/${this.accountId}`, {
      logo: this.account.logo,
      domain: this.account.domain,
      client_domain: this.account.client_domain,
      primary_color: this.account.primary_color,
      alternate_color: this.account.alternate_color,
      action_color: this.account.action_color,
      action_text_color: this.account.action_text_color,
    }).subscribe( patchResult => {
      patchResult.intake = patchResult.intake || {registration: [], followup: [], appointment: []};
      this.account = patchResult;
      this.snackBar.open('Account branding updated.', null, {
        duration: 2000
      });
    }, (error) => {
      this.snackBar.open(`Error updating branding: ${error}`, null, {
        duration: 2000
      });
    });
  }

  public updateIntake(): void {
    if ( this.account.intake &&
      this.account.intake.registration &&
      Array.isArray(this.account.intake.registration) &&
      !this.account.intake.registration.length ) {
      delete this.account.intake.registration;
    }
    if ( this.account.intake &&
      this.account.intake.appointment &&
      Array.isArray(this.account.intake.appointment) &&
      !this.account.intake.appointment.length ) {
      delete this.account.intake.appointment;
    }
    if ( this.account.intake &&
      this.account.intake.followup &&
      Array.isArray(this.account.intake.followup) &&
      !this.account.intake.followup.length ) {
      delete this.account.intake.followup;
    }
    console.log('patching with : ' + JSON.stringify(this.account.intake));
    this.api.patch<any>(`/account/${this.accountId}`, {
      intake: this.account.intake
    }).subscribe( patchResult => {
      patchResult.intake = patchResult.intake || {registration: [], followup: [], appointment: []};
      this.account = patchResult;
      this.snackBar.open('Account intake updated.', null, {
        duration: 2000
      });
    }, (error) => {
      this.snackBar.open(`Error updating intake: ${error}`, null, {
        duration: 2000
      });
    });
  }

  public updateModel(event): void {
    this.api.patch<any>(`/account/${this.accountId}`, {
      billing: this.account.billing
    }).subscribe( patchResult => {
      patchResult.intake = patchResult.intake || {registration: [], followup: [], appointment: []};
      this.account = patchResult;
      this.snackBar.open('Account services updated.', null, {
        duration: 2000
      });
    }, (error) => {
      this.snackBar.open(`Error updating options: ${error}`, null, {
        duration: 2000
      });
    });
  }


  public editCommissions(): void {
    const dialogRef = this.dialog.open(CommissionDialogComponent, {
      width: '750px',
      data: this.account
    });

    dialogRef.afterClosed().subscribe(commissions => {
      if ( commissions ) {
        this.api.patch<any>(`/account/${this.account.id}`, commissions).subscribe( result => {
          result.intake = result.intake || {registration: [], followup: [], appointment: []};
          this.userContext.account = result;
          this.snackBar.open('Commissions updated.', null, {
            duration: 2000
          });
        }, (error) => {
          this.snackBar.open(`Error updating commissions: ${error}`, null, {
            duration: 2000
          });
        });
      }
    });
  }


  public editAccount(): void {
    const dialogRef = this.dialog.open(AccountDialogComponent, {
      width: '850px',
      data: this.account
    });

    dialogRef.afterClosed().subscribe(account => {
      if ( account ) {
        this.api.patch<any>(`/account/${this.account.id}`, {
          name: account.name,
          type: account.type,
          external_id: account.external_id,
          fulfillment: account.fulfillment,
          contact: account.contact,
          billing: account.billing,
          logo: account.logo,
          country: account.country,
          discipline: account.discipline,
          supplier_id: account.supplier_id,
          distributor_id: account.distributor_id
        }).subscribe( result => {
          result.intake = result.intake || {registration: [], followup: [], appointment: []};
          this.userContext.accountObserver.next(result);
          this.snackBar.open('Account updated.', null, {
            duration: 2000
          });
        }, (error) => {
          this.snackBar.open(`Error updating information: ${error}`, null, {
            duration: 2000
          });
        });
      }
    });
  }

}
